// Customizzazione del componente Attachment per i bandi
// **Questo file è una copia del file src/components/View/Attachment.jsx**
// - Aggiunta della data di creazione o di effettiva del file
// - Aggiunta condizionale della data di creazione o di effettiva del file

import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import {
  Card,
  CardBody,
  CardTitle,
} from 'design-react-kit/dist/design-react-kit';
import { flattenToAppURL } from '@plone/volto/helpers';
import { viewDate } from 'design-comuni-plone-theme/helpers';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';

const messages = defineMessages({
  attachment: {
    id: 'attachment',
    defaultMessage: 'Allegato',
  },
  publication_date: {
    id: 'publication_date',
    defaultMessage: 'Pubblicato il:',
  },
});

const AttachmentBando = ({
  title,
  description,
  download_url,
  item,
  showModified = true,
}) => {
  const intl = useIntl();

  let dateValue = null;

  if (item.created) {
    dateValue = item.created;
  }

  if (item.effective) {
    dateValue = item.effective;
  }

  const showDate = dateValue
    ? `${intl.formatMessage(messages.publication_date)} ${viewDate(
        intl.locale,
        dateValue,
        'DD-MM-Y',
      )}`
    : null;

  return (
    <Card
      className="card card-teaser shadow p-4 mt-3 rounded attachment"
      noWrapper
      tag="div"
    >
      <Icon
        icon="it-clip"
        alt={intl.formatMessage(messages.attachment)}
        title={intl.formatMessage(messages.attachment)}
      />
      <CardBody tag="div">
        <CardTitle tag="h5">
          <a href={flattenToAppURL(download_url)}>{title}</a>
        </CardTitle>
        {description && <p>{description}</p>}
        {showModified && showDate && <p>{showDate}</p>}
      </CardBody>
    </Card>
  );
};

AttachmentBando.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  download_url: PropTypes.string,
  item: PropTypes.shape({
    effective: PropTypes.string,
    created: PropTypes.string,
  }),
  showModified: PropTypes.bool,
};

export default AttachmentBando;
